import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UsefulLinkService } from '../../../services/useful-link.service';
import { CompetitionService } from 'app/services/competition.service';
import { UsefulLink } from '../../../models/useful-link';

@Component({
  selector: 'app-useful-links-dashboard',
  templateUrl: './useful-links-dashboard.component.html',
  styleUrls: ['./useful-links-dashboard.component.scss']
})
export class UsefulLinksDashboardComponent implements OnInit, OnDestroy {

  usefulLinks: Array<UsefulLink> = [];
  lastEvaluatedKey: any;
  private currentCompetitionId: string;
  private routerSub: Subscription;

  constructor(
    private usefulLinkService: UsefulLinkService,
    private competitionService: CompetitionService,
    private router: Router
  ) { }

  ngOnInit() {
    this.currentCompetitionId = this.competitionService.getCompetitionId();
    this.getAll(null);
    
    // Subscribe to navigation events to reload useful links when user navigates to a different competition
    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const newCompetitionId = this.competitionService.getCompetitionId();
      // Only reload if competition actually changed
      if (newCompetitionId && newCompetitionId !== this.currentCompetitionId) {
        this.currentCompetitionId = newCompetitionId;
        this.usefulLinks = [];
        this.lastEvaluatedKey = null;
        this.getAll(null);
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  getNext() {
    this.getAll(this.lastEvaluatedKey);
  }

  getAll(lastEvaluatedKey?: string): void {
    this.usefulLinkService
      .getAll(lastEvaluatedKey)
      .subscribe((usefulLinks) => {
        this.usefulLinks = this.usefulLinks && lastEvaluatedKey ?
                           this.usefulLinks.concat(usefulLinks.Items) : usefulLinks.Items;
        this.lastEvaluatedKey = usefulLinks.LastEvaluatedKey;

      });
  }
}
